import SideModal from "components/SideModal";
import { useToast } from "contexts/ToastContext";
import { ChangeEvent, useRef, useState } from "react";
import { editSummon } from "services/prosecutorDecipilineService";
import { Summon } from "types";
import { LoadingIcon } from "utils/constant";
import "../../complaintRequest/styles/AddEvidenceModal.css";
import { useTranslation } from "contexts/i18nContext";

interface DecisionModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  summonData: Summon;
  onRefresh: any;
}

export default function AddAppealSummonDecisionModal({
  isOpen,
  setIsOpen,
  summonData,
  onRefresh,
}: DecisionModalProps) {
  const { t } = useTranslation();
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);

  const [formState, setFormState] = useState({
    files: [] as File[],
  });
  const fileInputRef = useRef<HTMLInputElement>(null);

  // const handleChange = (
  //   e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  // ) => {
  //   const { name, value } = e.target;
  //   setFormState((prev) => ({ ...prev, [name]: value }));
  // };

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormState((prev) => ({
        ...prev,
        files: [...prev.files, ...Array.from(e.target.files as FileList)],
      }));
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!summonData) return;

    setLoading(true);

    const data = new FormData();
    data.append("summon_decision_document", formState?.files[0] || "");

    const summon_id = summonData?.id || "";
    const isFormData = true;

    try {
      await editSummon(data, summon_id, isFormData);

      onRefresh();
      setIsOpen(false);
      showToast(t("successfullyCreated"), "success");
      setFormState({
        files: [] as File[],
      });
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
    } finally {
      setLoading(false);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current?.click();
  };

  if (!isOpen) return null;

  return (
    <SideModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={t("addAppealSummonDecision")}
    >
      <form onSubmit={handleSubmit} className="evidence-form">
        <section className="evidence-section">
          {/* ///////////// */}
          {/* Other forms */}
          {/* ///////////// */}
        </section>

        <section className="evidence-section">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t("decisionFile")}
          </label>
          <div className="file-upload-area" onClick={triggerFileInput}>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              multiple
              style={{ display: "none" }}
            />
            <p className="upload-text">{t("uploadFiles")}</p>
            {formState.files.length > 0 && (
              <div className="file-list">
                {formState.files.map((file, index) => (
                  <div key={index} className="file-item">
                    {file.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>

        <button
          type="submit"
          className="bg-black w-full text-white px-6 py-2 rounded-md hover:bg-gray-800"
          disabled={loading}
        >
          {loading ? (
            <div className="flex items-center justify-center">
              {LoadingIcon}
              {t("submitting")}...
            </div>
          ) : (
            t("addDecision")
          )}
        </button>
      </form>
    </SideModal>
  );
}
